<div class="modal-overlay" *ngIf="show">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faHistory"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'KNOWLEDGE_BASE.HISTORY.TITLE' | translate }}</h3>
          <p>{{ archive?.name }}</p>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="loading" class="loading-state">
        <div class="spinner"></div>
      </div>

      <div *ngIf="!loading && history.length === 0" class="empty-state">
        <div class="empty-icon">
          <fa-icon [icon]="faInfoCircle"></fa-icon>
        </div>
        <p>{{ 'KNOWLEDGE_BASE.HISTORY.EMPTY' | translate }}</p>
      </div>

      <div *ngIf="!loading && history.length > 0" class="history-list">
        <div class="history-card" *ngFor="let entry of history" [class.expanded]="selectedEntry?.id === entry.id"
          [class.active-card]="entry.is_active">
          <div class="card-main" (click)="toggleDetails(entry)">
            <div class="card-info">
              <div class="active-badge" *ngIf="entry.is_active">
                <fa-icon [icon]="faCheckCircle"></fa-icon>
                <span>{{ 'KNOWLEDGE_BASE.HISTORY.ACTIVE_VERSION' | translate }}</span>
              </div>
              <div class="timestamp">
                <div class="date-badge">
                  <fa-icon [icon]="faCalendarAlt"></fa-icon>
                  <span>{{ formatDate(entry.created_at) }}</span>
                </div>
                <div class="time-badge">
                  <fa-icon [icon]="faClock"></fa-icon>
                  <span>{{ formatTime(entry.created_at) }}</span>
                </div>
              </div>
              <div class="user-badge">
                <fa-icon [icon]="faUser"></fa-icon>
                <span>{{ entry.user }}</span>
              </div>
            </div>

            <div class="card-actions">
              <div class="expand-icon">
                <fa-icon [icon]="selectedEntry?.id === entry.id ? faChevronUp : faChevronDown"></fa-icon>
              </div>
            </div>
          </div>

          <div class="card-details" *ngIf="selectedEntry?.id === entry.id">
            <div class="details-section">
              <div class="snapshot-grid">
                <div class="snapshot-item">
                  <div class="key-row"><span class="key">{{ 'KNOWLEDGE_BASE.NAME' | translate }}</span></div>
                  <span class="value">{{ entry.name }}</span>
                </div>
                <div class="snapshot-item">
                  <div class="key-row"><span class="key">{{ 'KNOWLEDGE_BASE.SPLIT_METHOD' | translate }}</span></div>
                  <span class="value">{{ splitLabel(entry.split_method) }}</span>
                </div>
                <div class="snapshot-item">
                  <div class="key-row"><span class="key">{{ 'KNOWLEDGE_BASE.HISTORY.DELFOS_SERVER' | translate }}</span></div>
                  <span class="value">{{ delfosServerLabel(entry) }}</span>
                </div>
                <div class="snapshot-item">
                  <div class="key-row"><span class="key">{{ 'KNOWLEDGE_BASE.HISTORY.CONTAINER_NAME' | translate }}</span></div>
                  <span class="value">{{ entry.container_name || '—' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <app-button [text]="'BUTTON.CLOSE' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
    </div>
  </div>
</div>
